import {Home} from './componentes/HomePage'


function App() {
  return (
    <div id="App">
      <header>
        <h1>Border Box</h1>
      </header>
      <Home />
    </div>
  );
}

export default App;
